export default function EquipmentSpecTable({ rows }) {
  return (
    <table className="w-full border-collapse text-left text-sm">
      <tbody>
        {rows.map((row) => (
          <tr key={row.label} className="border-b border-gray-200">
            <th scope="row" className="w-2/5 py-3 pr-4 font-medium text-gray-500">
              {row.label}
            </th>
            <td className="py-3 text-gray-900">{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
